export const WORK_STATUSES = ["inbox", "todo", "in_progress", "done"] as const;
export type WorkStatus = (typeof WORK_STATUSES)[number];
export type WorkflowMode = "full" | "revision";
export const IMPACT_KEYS = ["roles", "client", "kpis", "systems"] as const;
export type ImpactKey = (typeof IMPACT_KEYS)[number];

export function processTags(title: string): string[] {
  return [
    ...new Set(
      (title.match(/\bcde\d+\b/gi) ?? []).map((code) => code.toLowerCase()),
    ),
  ];
}

export function qualificationMissing(p: {
  client?: string;
  consultant_person_id?: number;
  git_tier?: string;
  git_area?: string;
  goal?: string;
  next_action?: string;
}): string[] {
  return [
    !p.client?.trim() && "Client",
    !p.consultant_person_id && "Responsable CdE",
    !p.git_tier?.trim() && "Catégorie",
    !p.git_area?.trim() && "Domaine",
    !(p.goal?.trim() || p.next_action?.trim()) && "Résultat attendu",
  ].filter(Boolean) as string[];
}

export function canReviewImpact(role: string, impact: ImpactKey): boolean {
  return (
    role === "admin" ||
    (impact === "roles" ? role === "governance" : role === "cde")
  );
}

export function revisionMissing(
  p: {
    workflow_mode: string;
    work_status: string;
    target_version?: string;
    git_path?: string;
    revision_review?: string;
  },
  impacts: string[],
  approved: string[],
): string[] {
  return [
    p.workflow_mode !== "revision" && "Parcours de révision",
    p.work_status !== "in_progress" && "Travail en cours",
    !p.target_version?.trim() && "Version à publier",
    !p.git_path && "Définition liée",
    !p.revision_review?.trim() && "Compte rendu de revue",
    ...impacts.filter((k) => !approved.includes(k)).map((k) => `Revue : ${k}`),
  ].filter(Boolean) as string[];
}
